// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StrategicConsultingRouteImport } from './routes/strategic-consulting'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NewsRouteImport } from './routes/news'
import { Route as LogisticsTransportRouteImport } from './routes/logistics-transport'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as GoogleBusinessGuideRouteImport } from './routes/google-business-guide'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesCorporateInvestigationRouteImport } from './routes/services_.corporate-investigation'
import { Route as NewsSlugRouteImport } from './routes/news_.$slug'
import { Route as AdminNewsRouteImport } from './routes/admin.news'
import { Route as AdminGscRouteImport } from './routes/admin.gsc'
import { Route as AdminContactsRouteImport } from './routes/admin.contacts'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const StrategicConsultingRoute = StrategicConsultingRouteImport.update({
            id: '/strategic-consulting',path: '/strategic-consulting',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const LogisticsTransportRoute = LogisticsTransportRouteImport.update({
            id: '/logistics-transport',path: '/logistics-transport',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const GoogleBusinessGuideRoute = GoogleBusinessGuideRouteImport.update({
            id: '/google-business-guide',path: '/google-business-guide',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesCorporateInvestigationRoute = ServicesCorporateInvestigationRouteImport.update({
            id: '/services_/corporate-investigation',path: '/services/corporate-investigation',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news_/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const AdminNewsRoute = AdminNewsRouteImport.update({
            id: '/admin/news',path: '/admin/news',getParentRoute: () => rootRouteImport
          })
const AdminGscRoute = AdminGscRouteImport.update({
            id: '/admin/gsc',path: '/admin/gsc',getParentRoute: () => rootRouteImport
          })
const AdminContactsRoute = AdminContactsRouteImport.update({
            id: '/admin/contacts',path: '/admin/contacts',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,GoogleBusinessGuideRoute: GoogleBusinessGuideRoute,ImpressumRoute: ImpressumRoute,LoginRoute: LoginRoute,LogisticsTransportRoute: LogisticsTransportRoute,NewsRoute: NewsRoute,PrivacyRoute: PrivacyRoute,ServicesRoute: ServicesRoute,StrategicConsultingRoute: StrategicConsultingRoute,AdminContactsRoute: AdminContactsRoute,AdminGscRoute: AdminGscRoute,AdminNewsRoute: AdminNewsRoute,NewsSlugRoute: NewsSlugRoute,ServicesCorporateInvestigationRoute: ServicesCorporateInvestigationRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)